const initialState = {
  deviceInfo: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case 'USER_DEVICE/UPDATE_DEVICE_INFO':
      return {
        ...state,
        deviceInfo: action.deviceInfo,
      };
    default:
      return state;
  }
}
